<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">

                    <el-select size="small" v-model="formDatas.asbType" clearable placeholder="请选择费用类型" style="width: 180px"
                        @change="partserch">
                        <el-option label="正常缴纳" value="正常缴纳"></el-option>
                        <el-option label="补缴" value="补缴"></el-option>
                        <el-option label="退费" value="退费"></el-option>
                        <el-option label="基数补差" value="基数补差"></el-option>
                        <el-option label="特殊基数" value="特殊基数"></el-option>
                        <el-option label="离职预扣" value="离职预扣"></el-option>
                        <el-option label="讲师实缴" value="讲师实缴"></el-option>
                        <el-option label="比例补差" value="比例补差"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.asscId" placeholder="请选择参保主体" size="small" style="width: 140px"
                        @change="partserch" clearable>
                        <el-option v-for="item in assName_arr || []" :label="item.asscName" :value="item.asscId"
                            :key="item.asscId">
                        </el-option>
                    </el-select>
                    <el-input v-model="formDatas.asbCity" style="width: 140px;" size="small" placeholder="请输入归属地"
                        clearable></el-input>
                    <el-date-picker v-model="formDatas.asbMonthSettlement" type="month" value-format="yyyy-MM"
                        placeholder="选择结算月份" style="width: 140px;" size="small">
                    </el-date-picker>
                    <el-date-picker v-model="formDatas.asbMonthInsured" type="month" value-format="yyyy-MM"
                        placeholder="选择参保月份" style="width: 140px;" size="small">
                    </el-date-picker>
                    <el-input v-model="formDatas.asbuUserName" style="width: 140px;" size="small" placeholder="请输入姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.asbuUserCard" style="width: 140px;" size="small" placeholder="请输入身份证"
                        clearable></el-input>
                    <!-- <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select> -->
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="primary" size="small" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button>
                    <el-dropdown size="small" split-button type="warning" style="margin:0 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建公积金账单</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="asbuId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑公积金账单' : '新增公积金账单'" :visible.sync="dialog" width="70%" top="8vh" v-dialogDrag>
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;display: flex;flex-wrap: wrap;">
                        <div style="width: 50%;">
                            <el-form-item label="结算月份" prop="asbMonthSettlement">
                                <el-date-picker v-model="form.asbMonthSettlement" type="month" value-format="yyyy-MM"
                                    placeholder="选择月份">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="参保月份" prop="asbMonthInsured">
                                <el-date-picker v-model="form.asbMonthInsured" type="month" value-format="yyyy-MM"
                                    placeholder="选择月份">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="参保主体" prop="asscId">
                                <el-select v-model="form.asscId" placeholder="请选择" clearable>
                                    <el-option v-for="item in assName_arr || []" :label="item.asscName" :value="item.asscId"
                                        :key="item.asscId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div style="width: 50%;">
                            <el-form-item label="费用类型" prop="asbType">
                                <el-select v-model="form.asbType" clearable placeholder="请选择" style="width: 130px">
                                    <el-option label="正常缴纳" value="正常缴纳"></el-option>
                                    <el-option label="补缴" value="补缴"></el-option>
                                    <el-option label="退费" value="退费"></el-option>
                                    <el-option label="基数补差" value="基数补差"></el-option>
                                    <el-option label="特殊基数" value="特殊基数"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="归属地" prop="asbCity">
                                <el-input v-model="form.asbCity" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名" prop="asbuUserName">
                                <el-input v-model="form.asbuUserName" style="width: 50%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>


                        <el-form-item label="身份证号" prop="asbuUserCard">
                            <el-input v-model="form.asbuUserCard" style="width: 100%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size="medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/socialbasefund.xlsx', '公积金账单')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>
  
<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    addAjSocialBaseUserFund, deleteAjSocialBaseUserFund, getAjSocialBaseUserListFund, updateAjSocialBaseUserFund,
    uploadImportAjSocialBaseFund, uploadAjSocialBaseFund, getAjSocialServiceChargeList

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            assName_arr: [],
            sitId: '',
            bulkData: [],
            bulkDataCopy: [],
            bulkImport: false,
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'asbuId',
            dialog: false,
            edit: false,
            form: {
                asbMonthSettlement: '',
                asbType: '',
                asbMonthInsured: '',
                asbCity: '',
                asbuUserName: '',
                asbuUserCard: '',
            },
            rules: {
                asbMonthSettlement: [
                    { required: true, message: '请选择结算月份', trigger: 'change' }
                ],
                asbType: [
                    { required: true, message: '请选择费用类型', trigger: 'blur' }
                ],
                asbMonthInsured: [
                    { required: true, message: '请选择参保月份', trigger: 'change' }
                ],
                asbCity: [
                    { required: true, message: '请输入归属地', trigger: 'blur' }
                ],
            },
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,

                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",


                },
                {
                    field: "asbMonthSettlement",
                    key: "asbMonthSettlement",
                    fixed: 'left',
                    title: "结算月份",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuUserName",
                    key: "asbuUserName",
                    title: "姓名",
                    fixed: 'left',
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuUserCard",
                    key: "asbuUserCard",
                    title: "身份证号",
                    fixed: 'left',
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbType",
                    key: "asbType",
                    title: "费用类型",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbMonthInsured",
                    key: "asbMonthInsured",
                    title: "参保月份",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asscName",
                    key: "asscName",
                    fixed: 'left',
                    title: "参保主体",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbCity",
                    key: "asbCity",
                    title: "归属地",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundTotal",
                    key: "asbuFundTotal",
                    title: "公积金应交合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundPerson",
                    key: "asbuFundPerson",
                    title: "公积金个人合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundUnit",
                    key: "asbuFundUnit",
                    title: "公积金单位合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
            ],
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asbMonthSettlement",
                    key: "asbMonthSettlement",
                    fixed: 'left',
                    title: "结算月份",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuUserName",
                    key: "asbuUserName",
                    title: "姓名",
                    fixed: 'left',
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuUserCard",
                    key: "asbuUserCard",
                    title: "身份证号",
                    fixed: 'left',
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbType",
                    key: "asbType",
                    title: "费用类型",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbMonthInsured",
                    key: "asbMonthInsured",
                    title: "参保月份",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asscName",
                    key: "asscName",
                    fixed: 'left',
                    title: "参保主体",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbCity",
                    key: "asbCity",
                    title: "归属地",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundTotal",
                    key: "asbuFundTotal",
                    title: "公积金应交合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundPerson",
                    key: "asbuFundPerson",
                    title: "公积金个人合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "asbuFundUnit",
                    key: "asbuFundUnit",
                    title: "公积金单位合计",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                // { field: "createusername", key: "createusername", title: "创建人", width: 160, align: "center" },
                // { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 130,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                 {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleCopy(row)}
                                    >
                                        复制
                                    </el-button>
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                asbMonthSettlement: '',
                asbType: '',
                asbMonthInsured: '',
                asbCity: '',
                asbuUserName: '',
                asbuUserCard: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getAjSocialServiceChargeList().then(res => {
            this.assName_arr = res.data
        })
    },
    mounted() { },
    methods: {
        handleCopy(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    exportType: 2,
                    asbuIds: this.selectedRowKeysCollection.toString(),
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-social-base-user-fund/exportAjSocialBaseFund',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '公积金账单.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                const bulkdata = {
                    exportType: 1,
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-social-base-user-fund/exportAjSocialBaseFund',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '公积金账单.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];

                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        searchByNameField(labels, id) {
            this.bulkData = this.bulkDataCopy.filter(
                (x) => labels.length === 0 || labels.includes(x[id]),
            );
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                this.openLoading()
                uploadImportAjSocialBaseFund({
                    sitId: this.sitId
                }).then(res => {
                    this.loadings.close()
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()

                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjSocialBaseFund(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjSocialBaseUserFund({ asbuId: row.asbuId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjSocialBaseUserFund(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjSocialBaseUserFund(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.asbuId = row.asbuId
                    console.log(jsonObj);
                    updateAjSocialBaseUserFund(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjSocialBaseUserListFund(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjSocialBaseUserListFund(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjSocialBaseUserListFund(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  